import { render, staticRenderFns } from "./screen_admin_bodega.vue?vue&type=template&id=87be76e6&scoped=true"
import script from "./screen_admin_bodega.vue?vue&type=script&lang=js"
export * from "./screen_admin_bodega.vue?vue&type=script&lang=js"
import style0 from "./screen_admin_bodega.vue?vue&type=style&index=0&id=87be76e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87be76e6",
  null
  
)

export default component.exports